import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import apiGateWay from '../../serviceHandler'
import "./callWaiter.css"

const Index = () => {
	const tableData = JSON.parse(sessionStorage.getItem("urlParams"));

	useEffect(() => {
		getAssistance()
	}, []);
	const navigate = useNavigate();

	const [loaderItems, setLoaderItems] = useState([]);
	const [assistanceOptions, setAssistanceOptions] = useState([]);
	const [toasterData, setToasterData] = useState({});
	const [requestedAssistance, setRequestedAssistance] = useState({
		selected: "",
		custom: ""
	});

	const handleLoader = (items, action) => {
		switch (action) {
			case "add":
				setLoaderItems([
					...loaderItems,
					...items
				]);
				break;
			case "remove":
				setLoaderItems(loaderItems.filter(item => !items.includes(item)));
				break;
			default:
				break
		}
	};

	const getAssistance = async () => {
		try {
			handleLoader(["getAssistance"], "add");
			const response = await apiGateWay.get(`/keyconnect/simphony/GetAssistance`);
			handleLoader(["getAssistance"], "remove");
			if (response.status === 200) {
				setAssistanceOptions(response?.data?.result || [])
			} else {
				setToasterData({ type: "error", message: `Failed to get assistance options. Please type in your request.` })
			}
		} catch (error) {
			console.log(`getAssistance error`, error)
		}
	};

	const submitRequest = async () => {
		if (!tableData) {
			setToasterData({ type: "error", message: "Something went wrong. Please scan the QR code again" })
		}

		try {
			const params = {
				LocationID: 1,
				RevenueCenterObjectNum: Number(tableData?.rvc),
				TableNumber: Number(tableData?.tableNumer),
				// Task: Number(requestedAssistance.selected) || requestedAssistance.custom
			};
			if (requestedAssistance.selected) {
				params.id = Number(requestedAssistance.selected)
			} else {
				// params.id = Number(requestedAssistance.selected)
				params.Task = requestedAssistance.custom
			}

			handleLoader(["submitRequest"], "add");
			const response = await apiGateWay.post("/keyconnect/simphony/AskWaiterAssistance", params);
			handleLoader(["submitRequest"], "remove");
			if (response.status === 200) {
				setToasterData({ type: "success", message: response.data.message.title })
			} else {
				setToasterData({ type: "error", message: `Failed to submit assistance request` })
			}
		} catch (error) {
			console.log(`submitRequest error`, error)
		}
	};

	return <div className="startWrap">
		<div
			id="snackbar"
			className={`toaster-cover ${toasterData.type || ""} ${toasterData.type ? "show" : ""}`}
		>
			<span>{toasterData.message}</span>
		</div>
		<div className="start-menu-wrapper">
			<img src="/images/roaring_logo.svg" alt='EZmenu' className="logo-icon" />
			<div className='waiter-form-wrapper'>
				<form>
					<select
						className="form-select"
						aria-label="Default select example"
						onChange={ev => setRequestedAssistance({ selected: ev.target.value })}
						value={requestedAssistance.selected}
					>
						<option value={""}>Chose an assistance</option>
						{
							assistanceOptions.map(item => {
								return <option key={item.id} value={item.id}>{item.task}</option>
							})
						}
					</select>
					<textarea
						className="form-control"
						id="exampleFormControlTextarea1"
						placeholder='What do you need to tell the waiter?'
						rows="3"
						onChange={ev => setRequestedAssistance({ custom: ev.target.value })}
						value={requestedAssistance.custom}
					/>
					<div className="button-wrap">
						<button
							className='btn btn-menu'
							onClick={ev => {
								ev.preventDefault();
								navigate(`/home`)
							}}
						>Go back</button>
						<button
							className='btn btn-menu'
							disabled={!requestedAssistance.selected && !requestedAssistance.custom}
							onClick={ev => {
								ev.preventDefault();
								submitRequest()
							}}
						>Submit</button>
					</div>
				</form>
			</div>
		</div>
	</div>
};

export default Index